module.exports = __webpack_public_path__ + "img/cooperativeMedia4.a2d1dc9d.jpg";